"use strict";
const pcs = require('./pcs');
const oms = require('./oms');
const settlement = require('./settlement');
const mail = require('./mail');
const integration = require('./integration');
const validoo = require('./validoo');
const crm = require('./crm');
const endCustomerGateway = require('./end-customer-gateway');
const supplierGateway = require('./supplier-gateway');
const cron = require('./cron');
const alcoholLicense = require('./alcohol-license');
module.exports = {
    ...pcs,
    ...oms,
    ...settlement,
    ...mail,
    ...integration,
    ...validoo,
    ...crm,
    ...endCustomerGateway,
    ...supplierGateway,
    ...cron,
    ...alcoholLicense,
};
